import { EmptyLine } from "./EmptyLine";

export const Empty = {
  Line: EmptyLine,
};
